export default __webpack_public_path__ + "static/media/FG_40.2e1b9eda.png";